function presence(value) {
  if (value == null) return ''
  return String(value).trim()
}

function slotNumberFor(action) {
  return Number(action?.slot_number) || 1
}

/** Duplicate-row actions (slotNumber > 1) get their own group, labeled "<Name> (extra N)". */
function resolveInfluencerName(action) {
  const name =
    presence(action?.influencer_name) ||
    presence(action?.influencer?.full_name) ||
    presence(action?.auth_username) ||
    presence(action?.username) ||
    'Unknown influencer'

  const slotNumber = slotNumberFor(action)
  return slotNumber > 1 ? `${name} (extra ${slotNumber - 1})` : name
}

function resolveInfluencerKey(action) {
  const influencerId = presence(action?.influencer_id)
  const slotSuffix = `-slot-${slotNumberFor(action)}`
  if (influencerId) return `influencer-${influencerId}${slotSuffix}`

  const name = resolveInfluencerName(action)
  return `influencer-name-${name.toLowerCase()}${slotSuffix}`
}

export function groupTimelineScenarioAssets(actions = []) {
  const groupsByKey = new Map()

  actions.forEach((action) => {
    const key = resolveInfluencerKey(action)

    if (!groupsByKey.has(key)) {
      groupsByKey.set(key, {
        key,
        name: resolveInfluencerName(action),
        assets: [],
      })
    }

    groupsByKey.get(key).assets.push(action)
  })

  return Array.from(groupsByKey.values())
}
